import { Link } from 'react-router-dom';

export function LeaderboardPlayAgain({ to }: { to: string }) {
  return (
    <Link to={to} className="btn btn-primary btn-play-again">
      Play Again
    </Link>
  );
}
